import React from "react";

import Meta from "../components/Meta";
import Team from "../components/about/Team";
import Item from "../components/list/Item";
import HeaderSection from "../components/header/HeaderSection";

const Page = () => {
  return (
    <>
      <Meta
        title="About Engineering Book Club - Our Story, Our Mision and Our Values"
        desc="The Engineering Book Club is an online community for professional that wants to read books together."
      />

      <HeaderSection
        title="About Us"
        subtitle="Our mission is to build a community where everyone feels happy reading books together"
      />

      <section className="relative py-5">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          <div className="lg:flex lg:justify-between py-10">
            {/* <!-- Image --> */}
            <div className="lg:w-[55%]">
              <div className="relative">
                <img
                  src="/images/about-us.png"
                  width="200"
                  height="200"
                  className="mx-auto w-[100%] rounded-[1rem]"
                />
              </div>
            </div>

            {/* <!-- Info --> */}
            <div className="py-20 lg:w-[45%] lg:pl-16">
              <h3 className="text-jacarta-700 font-display mb-6 text-2xl dark:text-white">
                Our Story
              </h3>
              <p className="dark:text-jacarta-60 mb-8 text-lg leading-normal">
                We are passionate about reading books and we wanted to share this passion with
                others. This is why we have created this online community.
              </p>
              <p className="dark:text-jacarta-60 mb-8 leading-normal">
                We (Miguel & Jose) are close friends since we worked together a few years ago. We
                kept in contact and used to organise virtual coffees to chat about books and challenges
                when working remotely. This is why we decided to create an online community like this one,
                just to share our passion with other professionals.
              </p>

            </div>
          </div>
        </div>
      </section>
      <section className="dark:bg-jacarta-800 relative pt-24 lg:pb-10">
        <div className="container mt-50">
          <div className="lg:flex lg:justify-between">
            <div className="lg:w-[55%]">
              <h3 className="text-jacarta-700 font-display mb-6 text-2xl dark:text-white">
                Our Values
              </h3>
              <Item title="Honesty" description="Internet is full of Ads and we want to build a space where You are not the product. Don't expect any ads when joining us."/>
              <Item title="Passion" description="We’re passionate about what we do."/>
              <Item title="Transparency" description="We are building a community based on transparency."/>
            </div>
          </div>

        </div>
      </section>
      <section className="relative pt-24 lg:pb-10">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          <div className="mx-auto max-w-2xl py-5 text-center">
            <h1 className="font-display text-jacarta-700 mb-8 text-4xl font-medium dark:text-white">
              The Team
            </h1>
            <h2 className="dark:text-jacarta-60 text-lg leading-normal">
              We are incredibly passionate about reading books <br/>
              and would love to share the same passion with you
            </h2>
          </div>
        </div>
      </section>
      <Team/>
    </>
  );
};

export default Page;
